import clsx from 'clsx';

export type TStatusBadgeVariant =
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'outlined';

/**
 * These get mapped to the `TStatusBadgeVariant` in order to give them styling
 * variations and translate them.
 *
 * TODO: replace this import with the one from the API UITLS when this is refactored.
 * TODO: Move this out of the design system sign the type is tightly coupled to signups listing..
 */
export type TRecordStatus =
  | 'pending'
  | 'in-review'
  | 'approved'
  | 'accepted'
  | 'rejected';

/**
 * TODO: Addresss this when this is refactored outside the API
 */
export type TStatusConfig = Record<TRecordStatus, IStatusOptions>;

/**
 * Display mode for the status badge.
 */
export type TStatusDisplay = 'solid' | 'outlined';

/**
 * Options for a specific status.
 */
export interface IStatusOptions {
  /** The display label for the status. */
  label: string;
  /** The color variant to apply. */
  variant: TStatusBadgeVariant;
}

/**
 * Properties for the StatusBadge component.
 */
export interface IStatusBadgeProps {
  /** Optional CSS class name. */
  className?: string;
  /** The text to display in the badge. */
  label: string;
  /** The display style of the badge. */
  type?: TStatusDisplay;
  /** The visual variant of the badge. */
  variant: TStatusBadgeVariant;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a tag like badge with multiple colors and variants.
 */
export function StatusBadge({
  className,
  label,
  variant,
  type = 'solid',
}: IStatusBadgeProps) {
  let outerClassName = '';
  let typeClassName = '';

  if (type === 'solid') {
    if (variant === 'info') {
      typeClassName = 'bg-primary-100';
    }
    if (variant === 'success') {
      typeClassName = 'bg-green-100';
    }
    if (variant === 'warning') {
      typeClassName = 'bg-orange-100';
    }
    if (variant === 'error') {
      typeClassName = 'bg-red-100';
    }
  }

  if (type === 'outlined') {
    typeClassName = 'bg-white';
  }

  if (variant === 'info') {
    outerClassName = 'border-primary-300 text-primary-700';
  } else if (variant === 'success') {
    outerClassName = 'border-green-300 text-green-700';
  } else if (variant === 'warning') {
    outerClassName = 'border-orange-300 text-orange-700';
  } else if (variant === 'error') {
    outerClassName = 'border-red-300 text-red-700';
  }

  return (
    <div
      className={clsx(
        'inline-flex items-center justify-center rounded-full border px-3 py-1.5 sm:py-2',
        outerClassName,
        typeClassName,
        className
      )}
    >
      <div className="text-[10px] leading-none font-normal capitalize sm:text-xs">
        {label}
      </div>
    </div>
  );
}
